import { Slide } from '@features/powerpoint';
import {
  campaignInsightsCoverSlide,
  audienceProfileSlide,
  demographicProfileSlide,
  moreStatsSlide,
} from '.';
import { BuildReportOptions } from '../utils/build-presentation';
import { topStatesDmasLocationsSlide } from './top-states-dmas-locations';
import { visitorProfileSlide } from './visitor-profile';
import { visibleSlide } from '@features/executive-report/slides';

const topStatesDmasLocationsSlideVisible = (
  campaignAnalyticsReport: NonNullable<
    BuildReportOptions['campaignAnalyticsReport']
  >
): boolean =>
  [
    campaignAnalyticsReport.stateVisits,
    campaignAnalyticsReport.dmaVisits,
    campaignAnalyticsReport.brandLocationVisits,
  ].every(field => field.visible);

const moreStatsSlideVisible = (
  campaignAnalyticsReport: NonNullable<
    BuildReportOptions['campaignAnalyticsReport']
  >
) =>
  [
    campaignAnalyticsReport.proximityToHome,
    campaignAnalyticsReport.visitsByHourOfDay,
    campaignAnalyticsReport.visitsByDayOfWeek,
    campaignAnalyticsReport.timeToFirstVisitByDay,
  ].some(field => field.visible);

const visitorProfileSlideVisible = (
  campaignAnalyticsReport: NonNullable<
    BuildReportOptions['campaignAnalyticsReport']
  >
) =>
  [
    campaignAnalyticsReport.demographicProfile,
    campaignAnalyticsReport.stateVisits,
    campaignAnalyticsReport.dmaVisits,
    campaignAnalyticsReport.brandLocationVisits,
    campaignAnalyticsReport.proximityToHome,
    campaignAnalyticsReport.timeToFirstVisitByDay,
    campaignAnalyticsReport.visitsByHourOfDay,
    campaignAnalyticsReport.visitsByDayOfWeek,
  ].some(field => field.visible);

export const campaignInsightsSlides = (
  campaignAnalyticsReport: BuildReportOptions['campaignAnalyticsReport'],
  includedSlides: BuildReportOptions['customFields']['includedSlides']['campaignInsights']
): Slide[] => {
  if (!campaignAnalyticsReport) return [];

  return [
    ...visibleSlide({
      slide: campaignInsightsCoverSlide(),
      visible: includedSlides.cover,
    }),
    ...visibleSlide({
      visible:
        campaignAnalyticsReport.audienceProfile.visible &&
        includedSlides.audienceProfile,
      slide: audienceProfileSlide({
        audienceProfile: campaignAnalyticsReport.audienceProfile,
      }),
    }),
    ...visibleSlide({
      visible:
        campaignAnalyticsReport.demographicProfile.visible &&
        includedSlides.demographicProfile,
      slide: demographicProfileSlide({
        demographicProfile: campaignAnalyticsReport.demographicProfile,
      }),
    }),
    ...visibleSlide({
      visible:
        topStatesDmasLocationsSlideVisible(campaignAnalyticsReport) &&
        includedSlides.topLocations,
      slide: topStatesDmasLocationsSlide({
        stateVisits: campaignAnalyticsReport.stateVisits,
        dmaVisits: campaignAnalyticsReport.dmaVisits,
        brandLocationVisits: campaignAnalyticsReport.brandLocationVisits,
      }),
    }),
    ...visibleSlide({
      visible:
        moreStatsSlideVisible(campaignAnalyticsReport) &&
        includedSlides.moreStats,
      slide: moreStatsSlide({
        proximityToHome: campaignAnalyticsReport.proximityToHome,
        visitsByHourOfDay: campaignAnalyticsReport.visitsByHourOfDay,
        visitsByDayOfWeek: campaignAnalyticsReport.visitsByDayOfWeek,
        timeToFirstVisitByDay: campaignAnalyticsReport.timeToFirstVisitByDay,
      }),
    }),
    ...visibleSlide({
      visible:
        visitorProfileSlideVisible(campaignAnalyticsReport) &&
        includedSlides.visitorProfile,
      slide: visitorProfileSlide(campaignAnalyticsReport),
    }),
  ];
};
